import styled from 'styled-components';

const FadeIn = styled.div`
  ${({ responsive }) => responsive && `width: ${responsive.width};`}
  opacity: 0;
  animation: fade 200ms ease-in-out forwards;

  @media (min-width: 990px) {
    ${({ desktop }) => desktop && `width: ${desktop.width};`}
  }

  @keyframes fade {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;

export default FadeIn;
